import debounce from './debounce';

const formDataLayerHelper = (intl, fieldConfig) => {
  if (!fieldConfig.dataLayerCallback) {
    return false;
  }

  const callbacks = {
    filterSelected: (event) => {
      const pushValue = (filterHeader, filterItem, filterType) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'filterSelected',
          'eventCategory': 'Filter',
          'eventAction': 'Selected filter',
          'eventLabel': `Filter Header: ${filterHeader} | Filter Item ${filterItem} | Filter Type ${filterType}`,
          'eventValue': undefined,
          'eventOrigin': 'front-end',
          'eventVars': {
            'filterHeader': filterHeader,
            'filterItem': filterItem,
            'filterType': filterType,
          }
        });
      }

      if (event?.target && event.target.type === 'range') {
        debounce(() => {
          let filterHeader = intl.formatMessage({id: fieldConfig.label});
          let filterItem = `from 0 to $${event.target.value}`;
          let filterType = event.target.type;

          pushValue(filterHeader, filterItem, filterType);
        }, 1000);
      }
      else {
        const {label} = fieldConfig;
        let filterHeader = intl.formatMessage({id: label});
        let filterItem = '';
        let filterType = '';


        if (event.target && event.target.type === 'checkbox' && !event.target.checked) {
          return;
        }

        if (event.target && (event.target.type === 'checkbox' || event.target.type === 'radio')) {
          filterType = event.target.type;

          if (event.target.labels.length) {
            filterItem = event.target.labels[0].textContent;
          }
        }

        if (fieldConfig.type === 'select') {
          filterType = 'dropdown';
          if (Array.isArray(event)) {
            event.forEach((item) => {
              filterItem += filterItem ? `, ${item.value}` : item.value;
            });
          }
          else {
            filterItem = event.value;
          }
        }

        pushValue(filterHeader, filterItem, filterType);
      }
    }
  };

  return callbacks[fieldConfig.dataLayerCallback];
}

export {formDataLayerHelper};
